import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PageHeader } from '../../shared/page-header/page-header';
import { AuthService } from '../../core/auth/auth.service';

interface SettingCard {
  readonly title: string;
  readonly description: string;
  readonly icon: string;
  readonly link?: string;
  readonly permission: string;
}

@Component({
  selector: 'app-settings',
  imports: [RouterLink, PageHeader],
  templateUrl: './settings.html',
})
export class Settings {
  private readonly auth = inject(AuthService);

  private readonly cards: SettingCard[] = [
    {
      title: 'Utilizadores',
      description: 'Convide pessoas para a equipa e defina papéis (administrador, gestor, observador).',
      icon: 'fe-user-check',
      link: 'usuarios',
      permission: 'user:write',
    },
    {
      title: 'Caixas de e-mail',
      description: 'O endereço de cada módulo — por onde entram as participações e de onde saem as respostas.',
      icon: 'fe-mail',
      link: 'caixas',
      permission: 'user:write',
    },
    {
      title: 'Modelos de e-mail',
      description: 'O que as mensagens automáticas dizem a quem participa — e quem aprovou cada texto.',
      icon: 'fe-file-text',
      link: 'modelos-email',
      permission: 'user:write',
    },
    {
      title: 'Portal público',
      description: 'Os endereços para divulgar no site: registar uma participação e acompanhar pelo código.',
      icon: 'fe-globe',
      link: 'portal',
      permission: 'occurrence:read',
    },
  ];

  /** Só mostra os cards de configuração que o papel do utilizador pode gerir. */
  protected readonly visibleCards = computed(() => this.cards.filter((card) => this.auth.can(card.permission)));
}
